<template lang="html">
  <div>
    <pages-options :app-id="appId" />
    <div v-if="pageName">
      <div v-if="isPreview">
        <div class="preview-header">
          <div class="title">{{ getMessageText(messages.PREVIEW) }}</div>
        </div>
        <pages-preview :page-name="pageName" :app-id="appId" :platform="platform" />
      </div>
      <drag-drop-page v-else :page-name="pageName" :app-id="appId" />
    </div>
  </div>
</template>

<script lang="js">
  import { mapState } from "vuex";
  import PagesOptions from "@/views/PagesOptions";
  import PagesPreview from "@/views/PagesPreview";
  import DragDropPage from "@/views/drag-drop-pages/DragDropPage";

  export default {
    name: "pages",
    components: {
      PagesOptions,
      PagesPreview,
      DragDropPage
    },
    props: {
      appId: String
    },
    computed: {
      ...mapState([
        "pageInfo",
        "messages",
        "previewPlatform"
      ]),
      isPreview() {
        return this.pageInfo && this.pageInfo.isPreview;
      },
      pageName() {
        return this.pageInfo &&
        this.pageInfo.appId === this.appId &&
        this.pageInfo.currentPage
            ? this.pageInfo.currentPage
            : "";
      },
      platform() {
        return this.previewPlatform;
      }
    }
  };
</script>

<style scoped lang="scss">
  .preview-header {
    display: flex;
    justify-content: space-between;
    padding: 0.75rem 1rem;
    border-bottom: 1px solid var(--BORDER_GREY);
    .title {
      font-size: 0.8125rem;
      font-weight: bold;
      padding-right: 0.7rem;
    }
    .icon {
      height: 1.5rem;
      width: 1.5rem;
      fill: var(--BTN_BG_BLUE);
      cursor: pointer;
    }
  }
</style>
